import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const InspectionStatus = () => {
  return(
    <SettingsMetaData propertyName={"AssertInspectionStatus"} viewPropertyName={"Asset Inspection Status"} />
  )
};

export default InspectionStatus;
